<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <div style="padding: 10px; font-size: 14px; background-color: #4CAF50; color: white;">
    <span style="margin-right: 5px;">{{ currentDraft.title }}</span>
    <span v-for="({ id }, index) in path" :key="`element-path-element-${index}`">
      <font-awesome-icon icon="chevron-right" style="font-size: 12px;"/>
      <span
        style="margin: 0px 10px 0px 5px;"
        :style="{ 'font-weight': index === path.length - 1 ? 'bold' : 'normal', 'font-size': index === path.length - 1 ? '16px' : '14px' }">
        {{ currentDraft[elementType[index]][id].title || '無標題' }}
      </span>
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
      elementType: ['categories', 'groups', 'items', 'questions', 'options', 'questions', 'options']
    }
  },
  computed: {
    ...mapState('menuDraftModule', ['currentDraft']),
    ...mapGetters(['storeId'])
  },
  props: {
    path: Array
  }
}
</script>

<style lang="scss" scoped>
</style>
